/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcClearingV1ClosingPositionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CLEARING_V1_CLOSING_POSITION_STATE_ENTITY_NAME = 'ixc.clearing.v1.ClosingPosition';
export const ixcClearingV1ClosingPositionStateEntity = new schema.Entity<IxcClearingV1ClosingPositionState>(IXC_CLEARING_V1_CLOSING_POSITION_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcClearingV1ClosingPositionState) => `${entity.assetId}-${entity.date}` });

